import angular from 'angular';
import uiRouter from 'angular-ui-router';
import analyticsComponent from './analytics.component';

let analyticsModule = angular.module('app.containers.analytics', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('analytics', {
      url: '/analytics',
      template: '<analytics></analytics>'
    });
})

.component('analytics', analyticsComponent);

export default analyticsModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/analytics/analytics.js
 **/